import { DealerListing } from 'lib/models/DealerListing';
import CarouselVehicleCard from 'components/DealerListingsCarousel/CarouselVehicleCard';

interface Props {
  vehicles: DealerListing[];
}

export default function MobileSearchResultsCarousel({ vehicles }: Props): JSX.Element {
  return (
    <div className="vehicles" data-testid="mobile-carousel">
      <div className="scrolling-container">
        <div className="inner-scrolling-container">
          {vehicles.map((vehicle, index) => (
            <CarouselVehicleCard {...vehicle} key={vehicle.vin} position={index + 1} />
          ))}
        </div>
      </div>
      <style jsx>{`
        .vehicles {
          margin-top: 30px;
          width: 100%;
        }

        .scrolling-container {
          overflow-x: scroll;
          overflow-y: hidden;
          height: 270px;
          -webkit-overflow-scrolling: touch;
        }

        .inner-scrolling-container {
          width: 9999px;
        }
      `}</style>
    </div>
  );
}
